/**
 * Entidad StandardCategory
 * Define las categorías estándar de productos.
 * Estas categorías estan pensadas para unificar o agrupar productos de diferentes cuentas.
 */

export interface StandardCategory {
  id: string;
  parentId?: string;
  name: string;  // e.g., "Zapatos", "Pantalones", "Camisas"
  slug: string;
  description?: string;
  imageId?: string | null;
  order: number;
  status: StandardCategoryStatus; // ACTIVE, INACTIVE
  metadata?: {
    icon?: string;
    displayInMenu?: boolean;
    seoTitle?: string;
    seoDescription?: string;
    attributes?: string[];
  };
  createdAt: Date;
  updatedAt: Date;
  deletedAt?: Date | null;

  children: StandardCategory[];
  parent: StandardCategory | null;
}

export enum StandardCategoryStatus {
  ACTIVE = 'ACTIVE',
  INACTIVE = 'INACTIVE'
}

